/* eslint-disable jsx-a11y/control-has-associated-label */
import * as React from 'react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { useIntl } from 'react-intl';
import dayjs from 'dayjs';
import localforage from 'localforage';
import { IWidgetGraph } from '../../OnlinePanel/OnlinePanelState';
import { URL_GRAPHS, URL_VELOCITY } from '../../../router/constants';
import { isGraphOpenAtom, speedWidgetGraphAtom } from '../../Graphs/GraphState';
import useAnalytics from '../../../hooks/useAnalytics';
import VelocityOnline from '../../Graphs/Velocity';

export default function SpeedWidgetGraph(props: { vehicleId: number }): JSX.Element {
  const { trackEvent } = useAnalytics();
  const { formatMessage: f } = useIntl();
  const [speedWidgetGraph, setSpeedWidgetGraph] = useRecoilState<IWidgetGraph | null>(
    speedWidgetGraphAtom
  );
  const setIsGraphOpen = useSetRecoilState<boolean | number>(isGraphOpenAtom);

  const closeWidgetGraph = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    trackEvent(['Speed Widget', 'click', 'Close widget graph']);
    setSpeedWidgetGraph(null);
    localforage.setItem('widgetGraph', null);
    setIsGraphOpen(false);
  };

  const openSpeedPage = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    trackEvent(['Speed Widget', 'click', 'Open Speed page to new window']);
    window.open(`${URL_GRAPHS}${URL_VELOCITY}/${speedWidgetGraph?.vehicleId}`, '_blank');
  };

  const getDate = () => {
    if (speedWidgetGraph && speedWidgetGraph.timestamp) {
      return dayjs(speedWidgetGraph.timestamp).format('DD.MM.YYYY');
    }
    return '';
  };

  React.useEffect(() => {
    trackEvent(['Speed Widget', 'show', 'Widget graph']);
    return () => {
      if (speedWidgetGraph && speedWidgetGraph.timestamp !== undefined) {
        setSpeedWidgetGraph(null);
        trackEvent(['Speed Widget', 'close', 'Widget graph']);
        localforage.setItem('widgetGraph', null);
        setIsGraphOpen(false);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ background: '#fff', borderRadius: '4px', margin: '2px', width: '756px' }}>
      <div
        style={{
          padding: '10px 14px 10px 10px',
        }}
      >
        <div className="">
          <div style={{ display: 'inline-flex' }}>
            <a
              href=""
              onClick={closeWidgetGraph}
              className="cmd-icon cmd-icon-arrow-left-ext"
              title={f({ id: 'graph.onlinepanel.back' })}
              style={{
                color: '#494949',
                marginRight: '12px',
                top: '2px',
                position: 'relative',
              }}
            />
            {f({ id: 'graph.velocity.page.title' })}: {getDate()}
          </div>
          <div
            style={{
              float: 'right',
              padding: '2px 10px',
              textAlign: 'center',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
            className="e-button--gray mb-2"
            onClick={openSpeedPage}
          >
            {f({ id: 'table.detailBtn' })}
          </div>
        </div>
      </div>
      <div style={{ padding: '0 0 0 10px' }}>
        <React.Suspense fallback={<div>Loading...</div>}>
          <VelocityOnline vehicleId={props.vehicleId} />
        </React.Suspense>
      </div>
    </div>
  );
}
